export default __webpack_public_path__ + "static/intro-app-eeb0da28f32b0a12db44ed75ba288305.png";